// Profile of Alina Tselinina, German. Source of the profile page and of the PDF in this language.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina ist Software Engineer mit einem Hintergrund in Data Engineering, angewandter Mathematik und maschinellem Lernen und arbeitet heute an KI-gestützten Anwendungen und agentischen Systemen. Sie hat Erfahrung im Aufbau von APIs und Datenpipelines, in der Modernisierung von Anwendungen durch Cloud-Migration und in der Entwicklung ML-gestützter Dienste. Ihr Schwerpunkt ist es, LLMs und KI-Agenten über strukturierte Workflows, Integrationen, Tests und iterative Evaluierung mit zuverlässigen Softwaresystemen zu verbinden.',
  imageAlt: 'Porträt von Alina Tselinina',
  personal: {
    languages: 'Englisch, Polnisch',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Studium: Finanz- und Versicherungsmathematik',
      institution: 'Adam-Mickiewicz-Universität, Posen',
      degree: 'Abschluss: Master'
    },
    {
      period: '2009 - 2014',
      field: 'Studium: Mathematik',
      institution: 'Belarussische Staatliche Universität, Minsk',
      degree: 'Abschluss: Bachelor'
    }
  ],
  skills: [
    {
      title: 'Programmierung',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'KI und LLMs',
      description: 'Claude, MCP, KI-Agenten, LLM-Anpassung, Modelltraining und Evaluierung'
    },
    {
      title: 'Cloud und Daten',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Frameworks und APIs',
      description: 'FastAPI, Flask, Shiny, REST-APIs, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Data Engineering und DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Datenbanken und Orchestrierung',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Atlassian-Werkzeuge',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Seit März 2026',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Entwicklung von KI-Agenten, Konfiguration von Workflows und Integration von Werkzeugen.',
        'Anpassung von LLMs sowie Modelltraining und Evaluierung.',
        'Entwicklung und Integration KI-gestützter Anwendungen.',
        'Quantencomputing: Mitarbeit an der Softwareentwicklung für Quantenanwendungen.'
      ]
    },
    {
      period: 'Seit Mai 2025',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'App-Entwicklung.',
        'Implementierung von Unit- und UI-Tests zur Sicherung der Anwendungsqualität.'
      ]
    },
    {
      period: 'November 2022 - Februar 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Wartung und Verbesserung von Datenpipelines und Workflow-Orchestrierung.',
        'Entwicklung von Paketen zur Berichtsautomatisierung.'
      ]
    },
    {
      period: 'Juli 2022 - Oktober 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Entwicklung und Wartung von ETL-Pipelines.'
      ]
    },
    {
      period: 'März 2022 - Juni 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Entwurf und Entwicklung von REST-APIs und Backend-Diensten.',
        'Implementierung der Backend-Logik zur JSON-Verarbeitung.'
      ]
    },
    {
      period: 'November 2020 - März 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Entwurf und Entwicklung von REST-APIs und Backend-Diensten (Proof of Concept).',
        'Entwicklung und Wartung von ETL-Pipelines.',
        'Modernisierung von On-Premise-Anwendungen durch AWS-Migration und Umschreiben von R-Code in Python.',
        'XML-Validierung und Transformation in HTML.',
        'Entwicklung von Webanwendungen.'
      ]
    },
    {
      period: 'Mai 2020 - November 2020',
      title: 'Data Scientist, PSI Polska, Posen',
      description: [
        'Entwurf und Entwicklung von REST-APIs und Backend-Diensten mit einem Machine-Learning-Modell im Backend.',
        'Entwicklung eines Kundensegmentierungsmodells.'
      ]
    },
    {
      period: 'Januar 2019 - April 2020',
      title: 'Advanced Data Scientist, Analyx, Posen',
      description: [
        'Web Scraping und Entwicklung von Datenpipelines.',
        'Entwicklung von Webanwendungen.',
        'Marketing-Mix-Modellierung.',
        'Optimierung von Arbeitsabläufen.'
      ]
    },
    {
      period: 'Mai 2018 - Dezember 2018',
      title: 'Data Scientist, Posen',
      description: [
        'Entwicklung von ETL-Prozessen.',
        'Pflege von Bash-Skripten.',
        'Kundensupport und Ad-hoc-Analysen.'
      ]
    },
    {
      period: 'April 2017 - April 2018',
      title: 'Junior Analyst, Posen',
      description: [
        'Datenanalyse und Erstellung von Berichten.',
        'Erstellung von Dokumentation und Präsentationen.'
      ]
    }
  ]
};
